import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyServicesComponent } from './my-services.component';
import { SharedModule } from '../../../shared/shared.module';
import { IconsModule } from '../../../icons/icons.module';
import { FilterModule } from '../../../components/filter/filter.module';
import { RouterModule } from '@angular/router';
import { CardModule } from '../card/card.module';


@NgModule({
  declarations: [
    MyServicesComponent
  ],
  exports: [
    MyServicesComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    SharedModule,
    IconsModule,
    FilterModule,
    RouterModule
  ]
})
export class MyServicesModule { }
